import { FC, useState, useEffect } from "react";
import { IPropsAppUpdateModal } from "types/modal/TypeModal";
import useWindowSize from "types/other/dimensions";
import OverlayModalCommon from "utils/settingsModal/common/OverLayModalCommon";
import * as serviceWorker from '../../serviceWorkerRegistration';

const AppUpdateModal: FC<IPropsAppUpdateModal> = ({
  onClose,
  isOpen,
  force
}) => {
  const [waitingWorker, setWaitingWorker] = useState<any>();

  const onSWUpdate = (registration: any) => {
    setWaitingWorker(registration.waiting);
  };

  useEffect(() => {
    serviceWorker.register({ onUpdate: onSWUpdate });
  }, []);

  const viewportWidth = useWindowSize();

  const submit = () => {
    waitingWorker?.postMessage({ type: 'SKIP_WAITING' });
    onClose();
    window.location.reload();
  }

  if (!isOpen) return null;
  return (
    <OverlayModalCommon onClose={!force ? onClose : () => { }} open={isOpen}>
      <div
        className={
          viewportWidth >= 1200
            ? "contentModalSettingsMapPc scrollbar-div"
            : "contentModalSettingsMap"
        }
      >
        <div className="rowheaderModalSettingMap">
          {!force && <div onClick={onClose} className="icon3-close pointer" />}
          <div className="titleheaderModal">به روزرسانی</div>
        </div>

        <div className={force ? "contentUpdateText" : "contentUpdateText contentUpdateTextNotforce"}>
          {force && "نسخه نرم افزار شما قدیمی است و برای استفاده از خدمات می‌بایست به روزرسانی گردد."}
          {!force && "نسخه نرم افزار شما قدیمی است و برای استفاده از آخرین امکانات و خدمات می‌بایست به روزرسانی گردد."}
        </div>

        <div className="rowBtnUpdate">
          <div onClick={submit} className="BtnSettingsMapSubmit pointer">
            به روزرسانی
          </div>
          {!force && <div onClick={onClose} className="BtnSettingsMapCancel pointer">
            انصراف
          </div>}
        </div>
      </div>
    </OverlayModalCommon>
  );
};
export default AppUpdateModal;
